import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import BusinessDataList from "views/pages/business/BusinessDataList";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import AddBusiness from "views/pages/business/AddBusiness";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const BusinessList = () => {
  const [businessList, setBusinessList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [profileList, setUserProfileList] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [updateData, setUpdateData] = useState(null);
  const [businessCategory, setBusinessCategory] = useState([]);
  const [role, setRole] = useState("");
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteBusinessDetails)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = businessList.filter((o) => o.id !== id);
            setBusinessList(filter);
            fetchBusinessList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = businessList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const businlist = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(businlist[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    fetchBusinessList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  useEffect(() => {
    fetchBusinessCategory();
  }, []);

  const fetchBusinessList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "ASC",
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getBusinssList)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setBusinessList(results);
          setTotalRecord(totalCount);
        } else {
          setBusinessList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const fetchBusinessCategory = () => {
    const payload = {
      pageNo: 1,
      limit: 100,
      orderBy: "ASC",
      searchText: "",
    };
    APICall("post", payload, EndPoints.getBusinessCategory)
      .then((response) => {
        const { results } = response.data.data;
        if (response.status === 200 && results) {
          setBusinessCategory(results);
        } else {
          setBusinessCategory([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const fetchUserProfile = (user_id) => {
    APICall("post", { user_id }, EndPoints.getUserProfile)
      .then((response) => {
        const { data } = response.data;
        setUserProfileList(data[0]);
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitBusiness = () => {
    fetchBusinessList();
  };
  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Business
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <BusinessDataList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            businessList={businessList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchText={searchText}
            setSearchText={setSearchText}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            fetchUserProfile={fetchUserProfile}
            profileList={profileList}
            handleOpen={handleOpen}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      <AddBusiness
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={type === "edit" ? "Update Business" : "Add Business"}
        onSubmitBusiness={submitBusiness}
        updateData={updateData}
        businessCategory={businessCategory}
        fetchBusinessList={fetchBusinessList}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default BusinessList;
